import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as AppConstants from '../AppConstants';
import moment from 'moment';
import noImage from '../images/noimage.png';
import fire from '../images/fire.svg';
import { MessageCircle, ExternalLink } from 'react-feather';
import { getSysSetting, numberWithCommas } from '../Utils';

export class PropertyCard extends Component {
  static displayName = PropertyCard.name;

  constructor(props) {
    super(props);
  }

  // fixmeadd: Handler to save propertyRef before navigation
  handleImageClick = (e) => {
    const propertyRef = this.props.property?.propertyRef;
    if (propertyRef) {
      localStorage.setItem('PropertySearchRef', propertyRef);
      console.log('Saved propertyRef:', propertyRef);
    } else {
      console.warn('No propertyRef found for property:', this.props.property);
    }
    // Navigation will proceed via Link
  };

  renderRemarks() {
    if (this.props.showRemarks === true) {
      const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const formattedDate = this.props.property?.dateChanged
        ? new Date(this.props.property.dateChanged).toLocaleDateString('en-GB', dateOptions)
        : '';
      return (
        <div>
          <div className="row">
            <div className="col-10">
              <p className="m-0">
                <span className="font-weight-bold">
                  <i className="fas fa-info fa-lg mr-2 ml-1"></i>
                </span>
                {formattedDate}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-10">
              <p className="m-0 font-weight-bold">
                {this.props.property?.remarks}
              </p>
            </div>
          </div>
        </div>
      );
    }
  }

  renderFavouriteRemoveBtn() {
    if (this.props.showRemoveFavouriteBtn === true) {
      return (
        <p
          className="btn btn-danger d-block mb-0 mt-2 white"
          style={{ width: '90px' }}
          onClick={() =>
            this.props.mutation.mutate({
              id: this.props.property?.favouriteObj?.id,
              propertyRef: this.props.property?.propertyRef,
            })
          }
        >
          <i className="fas fa-trash"></i>
        </p>
      );
    }
  }

  renderGoToWebsiteBtn() {
    if (this.props.property?.showingOnWeb === true) {
      let url =
        getSysSetting(AppConstants.SysSettingId_PropertyWebUrl)?.stringValue +
        this.props.property?.propertyRef;
      return (
        <div
          onClick={(e) => {
            window.open(url, '_blank', 'noopener,noreferrer');
          }}
          className="mr-3 absolute-web"
        >
          <ExternalLink size={20} />
        </div>
      );
    }
  }

  renderAddToFavouritesBtn() {
    if (this.props.showFavouriteBtn === true) {
      return (
        <div
          onClick={(e) => {
            this.props.reasonModal(
              e,
              this.props.property?.id,
              this.props.property?.propertyRef,
            );
          }}
          className="mr-3 absolute-heart"
        >
          <i className="far fa-heart"></i>
        </div>
      );
    }
  }

  renderAddToHotPropertiesBtn() {
    if (this.props.showHotBtn === true) {
      return (
        <div
          onClick={(e) => {
            this.props.reasonModal(
              e,
              this.props.property?.id,
              this.props.property?.propertyRef,
              20, // Hot Property Reason Id
            );
          }}
          className="mr-3 absolute-fire"
        >
          <img
            className="mr-2"
            src={fire}
            alt="fire"
            style={{ width: '16px', height: '24px' }}
          />
        </div>
      );
    }
  }

  renderLeaveFeedbackBtn() {
    if (this.props.showFeedbackBtn === true) {
      return (
        <div
          onClick={(e) => {
            this.props.feedbackModal(
              e,
              this.props.property?.id,
              this.props.property?.propertyRef,
              this.props.buyerProperty?.id,
            );
          }}
          className="mr-3 absolute-heart"
        >
          <MessageCircle size={20} />
        </div>
      );
    }
  }

  renderSelectCheckbox() {
    if (this.props.showSelectCheckbox === true) {
      return (
        <input
          type="checkbox"
          name="propertyId[]"
          value={this.props.property?.id}
          className="absolute-checkbox"
          onClick={this.props.handleCheck}
          data-property={JSON.stringify(this.props.property)}
        />
      );
    }
  }

  renderBuyerPropertyRemoveBtn() {
    if (this.props.showRemoveBuyerPropertyBtn === true) {
      return (
        <p
          className="btn btn-danger d-block mb-0 mt-2 white"
          style={{ width: '90px' }}
          onClick={() =>
            this.props.mutation.mutate({
              id: this.props.buyerProperty?.id,
              propertyRef: this.props.property?.propertyRef,
            })
          }
        >
          <i className="fas fa-trash"></i>
        </p>
      );
    }
  }

  render() {
    return (
      <div
        className="d-flex col-12 col-md-6 col-xl-4 mb-2"
        key={this.props.index}
      >
        <div className="item">
          <Link
            to={{
              pathname: '/PropertyDetails',
            }}
            state={{
              query: {
                property: this.props.property,
              },
              prevPath: { path: this.props.location.pathname },
            }}
            style={{
              textDecoration: 'none',
              color: 'black',
            }}
            onClick={this.handleImageClick} // fixmeadd: Save propertyRef
          >
            {this.props.property?.coverImg != null ? (
              <img
                src={this.props.property.coverImg}
                alt="firstImage"
                className="img-fluid w-100 thumb-image"
                data-property-ref={this.props.property?.propertyRef} // fixmeadd: Add data attribute
              />
            ) : (
              <img
                src={noImage}
                alt="defaultImage"
                className="img-fluid w-100 thumb-image"
                data-property-ref={this.props.property?.propertyRef} // fixmeadd: Add data attribute
              />
            )}
          </Link>
          {this.props.property.forSaleOrToLet === false ? (
            <small
              className="for-Sale-or-for-Let"
              style={{ background: 'green', padding: '2px' }}
            >
              For Sale
            </small>
          ) : (
            <small
              className="for-Sale-or-for-Let"
              style={{ background: 'red', padding: '2px' }}
            >
              To Let
            </small>
          )}
          <small className="ribbon">Ref:{this.props.property?.propertyRef}</small>
        </div>
        <div className="non" style={{ fontSize: '10px' }}>
          <p className="font-weight-bold mb-0 title mt-4">
            {this.props.property?.propertyTypeName}
          </p>
          <p className="font-weight-bold mb-0 title">
            {this.props.property?.localityName}
          </p>
          <p className="font-weight-bold mb-2 title">
            {this.props.property?.propertyStateName}
          </p>
          <p className="mb-2 price font-weight-bold">
            €
            {this.props.property?.forSaleOrToLet === false
              ? numberWithCommas(this.props.property?.propertyForSale?.price)
              : numberWithCommas(this.props.property?.propertyToLet?.longLetRate) +
                ' ' +
                this.props.property?.propertyToLet?.leaseRatePeriod}
          </p>
          {this.props.property?.forSaleOrToLet === true &&
            this.props.property?.propertyToLet?.lettingNextAvail && (
              <p className="m-0">
                <span className="font-weight-bold">
              <i className="fas fa-clock mr-2"></i>
            </span>
                {moment(this.props.property.propertyToLet.lettingNextAvail).format('DD/MM/YYYY')}
              </p>
          )}
          <p className="m-0">{this.props.property?.ByAppointment}</p>
          <p className="m-0">
            <span className="font-weight-bold">
              <i className="fas fa-bed mr-2"></i>
            </span>
            {this.props.property?.bedrooms} bedrooms
          </p>
          <p className="m-0" style={{ fontSize: '10px !important' }}>
            <span className="font-weight-bold">
              <i className="fas fa-expand fa-lg mr-2"></i>
            </span>
            {this.props.property?.areaSqMtrs} SQMT
          </p>
          {this.renderRemarks()}
          {this.renderFavouriteRemoveBtn()}
          {this.renderGoToWebsiteBtn()}
          {this.renderAddToFavouritesBtn()}
          {this.renderAddToHotPropertiesBtn()}
          {this.renderLeaveFeedbackBtn()}
          {this.renderSelectCheckbox()}
          {this.renderBuyerPropertyRemoveBtn()}
        </div>
      </div>
    );
  }
}